// extracted by mini-css-extract-plugin
module.exports = {"hidden":"drag-drop_hidden__kics9"};